"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18nDefaultValues = void 0;
exports.i18nDefaultValues = {
    InsurancePeriod: {
        title: 'Количество застрахованных',
        subtitle: 'Застраховать можем любого, а вот оформить полис можно только с 18 лет',
        labels: {
            startPolicy: 'Дата начала',
            endPolicy: 'Дата окончания',
            coverageItems: 'Введите название спорта',
            policyOnYear: 'Полис на год',
        },
        errors: {
            requiredEndDate: 'Укажите дату окончания действия полиса',
        },
    },
};
